import dayjs from "dayjs";

/**
 * Formatea una fecha según su contenido:
 * - Si la hora es 00:00:00 → muestra solo la fecha (DD/MM/YYYY)
 * - Si tiene hora/minuto → muestra fecha y hora (DD/MM/YYYY hh:mm a)
 * @param {string|Date|null} dateStr
 * @returns {string}
 */
export const formatDateTime = (dateStr) => {
  if (!dateStr) return "";
  const date = dayjs(dateStr);
  if (!date.isValid()) return "";

  const hasTime =
    date.hour() !== 0 || date.minute() !== 0 || date.second() !== 0;

  return hasTime
    ? date.format("DD/MM/YYYY hh:mm a")
    : date.format("DD/MM/YYYY");
};

export const toLocalDateTime = (pickerDate) => {
  if (!pickerDate) return null;

  return new Date(
    pickerDate.year,
    pickerDate.month.number - 1,
    pickerDate.day,
    pickerDate.hour,
    pickerDate.minute
  );
};

export const toApiDateTimeString = (date) => {
  if (!date) return null;

  // Si es instancia de Date
  if (date instanceof Date) {
    return dayjs(date).format("YYYY-MM-DDTHH:mm:ss");
  }

  // Si es un objeto del calendario
  if (date.year) {
    const d = new Date(
      date.year,
      date.month.number - 1,
      date.day,
      date.hour,
      date.minute
    );
    return dayjs(d).format("YYYY-MM-DDTHH:mm:ss");
  }

  return null;
};
